"use strict";

import axios from "axios";
import store from "@/store/index";
import { getCookie } from "@/utils";
const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const BASE_URL = process.env.VUE_APP_ACCOUNT_URL;

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    config.url = BASE_URL + config.url;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status == 401) {
      store.dispatch("user/logout");
    }
    return Promise.reject(error);
  }
);

export default _axios;
export async function request(data) {
  if (
    !(localStorage.getItem("lastToken") === getCookie("auth_token")) &&
    getCookie("auth_token") &&
    localStorage.getItem("lastToken")
  ) {
    // 防止无限循环请求
    localStorage.setItem("lastToken", getCookie("auth_token"));
    store.commit("user/SAVE_AUTH_TOKEN", { token: getCookie("auth_token") });
    store.dispatch("user/getUserInfo");
  } else {
    localStorage.setItem("lastToken", getCookie("auth_token"));
  }
  _axios.defaults.headers.common["Authorization"] = getCookie("auth_token");
  return new Promise((resolve, reject) => {
    _axios
      .request(data)
      .then((response) => {
        if (response.data.err_code == 0) {
          resolve(response.data.ret);
        } else {
          reject(response.data);
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
}
